<template>
  <div class="index-page">
    <!-- Header -->
    <header id="header" class="header d-flex align-items-center fixed-top">
      <div
        class="container-fluid position-relative d-flex align-items-center justify-content-between"
      >
        <a href="index.html" class="logo d-flex align-items-center">
          <h1 class="sitename">3GTAPP</h1>
        </a>
        <nav id="navmenu" class="navmenu">
          <a href="/index.html">
            <img
              class="mobile-nav-toggle"
              :src="pngIcon"
              alt="Menu icon"
              width="48"
              height="48"
              style="display: block !important"
            />
          </a>
        </nav>
      </div>
    </header>

    <!-- Main Content -->
    <main class="main">
      <!-- Hero Section -->
      <section id="hero" class="hero section">
        <img
          :src="require('@/assets/login/assets/img/hero-bg.jpg')"
          alt=""
          data-aos="fade-in"
          class=""
        />

        <div class="container text-center" data-aos="fade-up" data-aos-delay="100">
          <div class="row justify-content-center">
            <div class="col-lg-8">
              <h2>Welcome to 3GTAPP</h2>
              <p
                style="
                  font-family:
                    Helvetica,
                    Playfair Display;
                "
              >
                <span
                  id="main-title"
                  v-html="isMobile ? '您的最佳<br>顧客體驗管理系統' : '您的最佳顧客體驗管理系統'"
                >
                </span>
              </p>

              <!-- Login Form using Vue form but with original HTML structure -->
              <el-form
                ref="loginForm"
                :model="loginForm"
                :rules="loginRules"
                class="input-form"
                autocomplete="on"
                label-position="left"
                @submit.native.prevent
              >
                <!-- Username Input -->
                <el-form-item prop="username">
                  <div class="input-group">
                    <span class="input-icon">
                      <img :src="require('@/assets/login/assets/img/user.png')" alt="user icon" />
                    </span>
                    <el-input
                      ref="username"
                      v-model="loginForm.username"
                      placeholder="請輸入帳號"
                      name="username"
                      type="text"
                      tabindex="1"
                      autocomplete="on"
                      class="input-field"
                      @input="filterAlphanumeric('username')"
                    />
                  </div>
                </el-form-item>

                <!-- Password Input -->
                <el-tooltip
                  v-model="capsTooltip"
                  content="Caps lock is On"
                  placement="right"
                  manual
                >
                  <el-form-item prop="password">
                    <div class="input-group">
                      <span class="input-icon">
                        <img :src="require('@/assets/login/assets/img/lock.png')" alt="lock icon" />
                      </span>
                      <el-input
                        :key="passwordType"
                        ref="password"
                        v-model="loginForm.password"
                        :type="passwordType"
                        placeholder="請輸入密碼"
                        name="password"
                        tabindex="2"
                        autocomplete="off"
                        class="input-field"
                        @input="filterAlphanumeric('password')"
                        @keyup.native="checkCapslock"
                        @blur="capsTooltip = false"
                        @keyup.enter.native="handleLogin"
                      />
                      <span class="toggle-password" @click="showPwd">
                        <img
                          :src="
                            passwordType === 'password'
                              ? require('@/assets/login/assets/img/hidden.png')
                              : require('@/assets/login/assets/img/eye.png')
                          "
                          alt="toggle password"
                        />
                      </span>
                    </div>
                  </el-form-item>
                </el-tooltip>

                <!-- Login Button -->
                <el-button
                  :loading="loading"
                  type="primary"
                  size="large"
                  class="btn-get-started"
                  @click.native.prevent="handleLogin"
                >
                  登入
                </el-button>
              </el-form>
              <div style="line-height: 24px; max-height: 150px; overflow: auto">
                <template v-for="(item, index) in noticeList">
                  <div
                    v-html="item"
                    style="line-height: 20px; font-size: 16px; margin: 5px 0px; color: red"
                  ></div>
                  <!-- <span style="line-height: 20px; font-size: 16px">
            {{ noticeList.length > 1 ? index + 1 + "." : "" }}{{ item }}
          </span> -->
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer Company Link -->
        <a href="https://www.itainctw.com/" target="_blank" class="fixed-bottom-company-link">
          <div class="fixed-bottom-company" style="color: rgb(0, 103, 187)">
            2025©智遊旅程股份有限公司
          </div>
        </a>
      </section>
    </main>

    <!-- Scroll Top -->
    <a href="#" id="scroll-top" class="scroll-top d-flex align-items-center justify-content-center">
      <i class="bi bi-arrow-up-short"></i>
    </a>

    <!-- Preloader -->
    <div id="preloader"></div>

    <!-- Vue Dialog (preserve original functionality) -->
    <el-dialog title="Or connect with" :visible.sync="showDialog">
      Can not be simulated on local, so please combine you own business simulation! ! !
      <br />
      <br />
      <br />
      <social-sign />
    </el-dialog>
  </div>
</template>

<script>
import { validUsername } from '@/utils/validate'
import SocialSign from './components/SocialSignin'
import { getEnvironment } from '@/api/unity'
import applogo from '@/assets/images/logo3gtapp.png'
import logotext from '@/assets/images/logoText.png'
import pngIcon from '@/assets/login/assets/img/png.png'
import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'
import { getRangeSysNotice } from '@/api/system'

export default {
  name: 'Login',
  components: { SocialSign },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.trim() == '') {
        callback(new Error('帳號輸入錯誤'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error('請輸入密碼'))
      } else {
        callback()
      }
    }
    return {
      environment: '',
      loginForm: {
        username: '',
        password: '',
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      logo: applogo,
      logotext: logotext,
      pngIcon: pngIcon,
      isRemember: false,
      noticeList: [],
      isMobile: false,
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true,
    },
  },
  async created() {
    const body = document.body
    const rect = body.getBoundingClientRect()
    this.isMobile = rect.width - 1 < 992
    this.$store.dispatch('app/showDialog', false)

    if (process.env.NODE_ENV == 'development') {
      // this.loginForm.username = "0927373973";
      // this.loginForm.password = "ja$19840528";
    }

    await getRangeSysNotice()
      .then(response => {
        debugger
        console.log(response)
        response.data.forEach((element, index) => {
          console.log(element, index)
          if (response.data.length > 1) {
            element = index + 1 + '. ' + element
          }
          element = element.replace(/\n/g, '<br />')
          this.noticeList.push(element)
        })
      })
      .catch()
    await this.getEnvironment()
  },
  mounted() {
    if (this.loginForm.username === '') {
      this.$refs.username.focus()
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus()
    }

    // Initialize original JavaScript functionality
    this.initializeOriginalJS()

    // Update title break based on screen size
    this.updateTitleBreak()
    window.addEventListener('resize', this.updateTitleBreak)
  },
  destroyed() {
    window.removeEventListener('resize', this.updateTitleBreak)
  },
  methods: {
    initializeOriginalJS() {
      // Scroll functionality
      const toggleScrolled = () => {
        const selectBody = document.querySelector('body')
        const selectHeader = document.querySelector('#header')
        if (!selectHeader) return
        window.scrollY > 100
          ? selectBody.classList.add('scrolled')
          : selectBody.classList.remove('scrolled')
      }

      document.addEventListener('scroll', toggleScrolled)
      window.addEventListener('load', toggleScrolled)

      // Scroll top button
      const scrollTop = document.querySelector('.scroll-top')
      if (scrollTop) {
        const toggleScrollTop = () => {
          window.scrollY > 100
            ? scrollTop.classList.add('active')
            : scrollTop.classList.remove('active')
        }

        scrollTop.addEventListener('click', e => {
          e.preventDefault()
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        })

        window.addEventListener('load', toggleScrollTop)
        document.addEventListener('scroll', toggleScrollTop)
      }

      // Remove preloader
      const preloader = document.querySelector('#preloader')
      if (preloader) {
        setTimeout(() => {
          preloader.remove()
        }, 1000)
      }
    },

    updateTitleBreak() {
      const title = document.getElementById('main-title')
      if (!title) return
      if (window.innerWidth <= 768) {
        title.innerHTML = '您的最佳<br>顧客體驗管理系統'
      } else {
        title.innerHTML = '您的最佳顧客體驗管理系統'
      }
    },

    filterAlphanumeric(field) {
      const cleaned = this.loginForm[field].replace(/[^A-Za-z0-9]/g, '')
      if (this.loginForm[field] !== cleaned) {
        this.loginForm[field] = cleaned
      }
    },

    async getEnvironment() {
      const res = await getEnvironment()

      if (res.success) {
        if (res.message == '正式環境') {
          this.environment = ''
        } else {
          this.environment = res.message
        }
      }
    },
    changeRemember(val) {
      if (val) {
        var str = this.encryp(this.loginForm.password)
        Cookies.set('up', str, {
          expires: 30,
        })
      } else {
        Cookies.remove('up')
      }
    },
    encryp(data) {
      if (typeof data === 'object') {
        try {
          data = JSON.stringify(data)
        } catch (error) {
          console.log('error:', error)
        }
      }
      const dataHex = CryptoJS.enc.Utf8.parse(data)
      const keyHex = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_KEY)
      const ivHex = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_IV)
      const encrypted = CryptoJS.AES.encrypt(dataHex, keyHex, {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      })
      let encryptedVal = encrypted.ciphertext.toString()
      return encryptedVal
    },
    decrypt(encryptedVal) {
      let encryptedHexStr = CryptoJS.enc.Hex.parse(encryptedVal)
      let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
      const keyHex = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_KEY)
      const ivHex = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_IV)
      let decrypt = CryptoJS.AES.decrypt(srcs, keyHex, {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      })
      let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
      return decryptedStr.toString()
    },
    checkPassword() {
      const enPassword = Cookies.get('up') ? Cookies.get('up') : ''
      if (enPassword) {
        this.loginForm.password = this.decrypt(enPassword)
        this.isRemember = true
      } else {
        this.loginForm.password = ''
        this.isRemember = false
      }
    },
    checkCapslock(e) {
      const { key } = e
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z'
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('user/login', this.loginForm)
            .then(() => {
              this.changeRemember(this.isRemember)
              this.$router.push({
                path: this.redirect || '/',
                query: this.otherQuery,
              })
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
  },
}
</script>

<style lang="scss">
/* Import Original Main CSS */
@import '../../assets/login/assets/css/main.css';

/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

/* Basic Bootstrap-like utility classes */
.d-flex {
  display: flex !important;
}
.align-items-center {
  align-items: center !important;
}
.justify-content-between {
  justify-content: space-between !important;
}
.justify-content-center {
  justify-content: center !important;
}
.text-center {
  text-align: center !important;
}
.position-relative {
  position: relative !important;
}
.fixed-top {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  left: 0 !important;
  z-index: 1030 !important;
}
.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
.col-lg-8 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
@media (min-width: 992px) {
  .col-lg-8 {
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
}
.d-xl-none {
  display: none !important;
}
@media (max-width: 1199.98px) {
  .d-xl-none {
    display: block !important;
  }
}

/* Fix mobile nav toggle display issue */
.mobile-nav-toggle {
  cursor: pointer !important;
  pointer-events: auto !important;
}

/* Element UI Integration with Original Design */
:deep(.el-input) {
  width: 100%;

  .el-input__inner {
    border: none !important;
    background: transparent !important;
    outline: none !important;
    width: 100% !important;
    padding: 0 !important;
    box-shadow: none !important;
    font-size: 1rem !important;
    color: #333 !important;

    &::placeholder {
      color: #666 !important;
      opacity: 0.8 !important;
    }

    &:focus {
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
    }

    &:hover {
      background: transparent !important;
      border: none !important;
    }
  }
}

:deep(.el-form-item) {
  margin-bottom: 0 !important;

  .el-form-item__content {
    line-height: normal;
  }

  .el-form-item__error {
    position: static;
    padding-top: 4px;
  }
}

/* Override any Element UI button styling for login button */
:deep(.btn-get-started) {
  &.el-button {
    color: var(--contrast-color) !important;
    background: var(--accent-color) !important;
    border-color: var(--accent-color) !important;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 1px;
    padding: 10px 40px;
    margin: 30px 0 0 0;
    border-radius: 50px;
    transition: 0.3s;
    box-shadow: 0px 1px 10px -1px rgba(255, 255, 255, 0.5);
    width: 100%;

    &:hover {
      background: color-mix(in srgb, var(--accent-color) 90%, white 15%) !important;
      border-color: color-mix(in srgb, var(--accent-color) 90%, white 15%) !important;
    }

    &:focus {
      background: var(--accent-color) !important;
      border-color: var(--accent-color) !important;
    }
  }
}
</style>
